import React from "react";
import type {FunctionComponent} from "react";
import {isAppEnvDev} from "../../../config/environment";



export const WhenEnvIsDev: FunctionComponent = ({children}) => {
  if (!isAppEnvDev) {
    return null;
  }
  return <>{children}</>;
}
